export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15197.ea992cc2.jpg";